import http from "../utils/http";

export const fetchBankDataByIban = async (
  bankIban?: string
): Promise<Response> => {
  return await http.get(`/api/banks/find-by-iban?iban=${bankIban}`);
};
